"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _GridAreaContainer = _interopRequireDefault(require("@sprinx/react-mui-components/GridAreaContainer"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _Zoom = _interopRequireDefault(require("@material-ui/core/Zoom"));

var _AvailabilityFieldPreview = _interopRequireDefault(require("../../../components/AvailabilityFieldPreview"));

var _ProductAvailabilityFieldPreviewWithPopup = _interopRequireDefault(require("./ProductAvailabilityFieldPreviewWithPopup"));

var _ProductAvailabilityFieldPreviewWithPopupItem = _interopRequireDefault(require("./ProductAvailabilityFieldPreviewWithPopupItem"));

var _ProductDetailNote = _interopRequireDefault(require("./ProductDetailNote"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _extends2.default)({}, theme.typography.body1),
    container: {
      display: 'flex',
      alignItems: 'center',
      paddingBottom: theme.spacing(1)
    },
    separator: {
      marginLeft: theme.spacing(1.5),
      marginRight: theme.spacing(1.5),
      height: 18,
      width: 1.5,
      backgroundColor: theme.palette.common.black
    },
    text: {
      fontWeight: 300
    },
    labelsContainer: {
      display: 'flex',
      alignItems: 'center',
      marginTop: theme.spacing(1)
    },
    free: {
      color: theme.palette.primary.main,
      fontWeight: 500
    },
    showroom: {
      color: theme.palette.secondary.main,
      fontWeight: 500
    },
    notAvailable: {
      color: '#FFA6A6'
    }
  };
}, {
  name: 'ProductDetailStockInfoDesktop'
});

function ProductDetailStockInfoDesktop(_ref) {
  var available = _ref.available,
      pClasses = _ref.classes,
      className = _ref.className,
      delInfo = _ref.delInfo,
      product = _ref.product,
      renderToGridArea = _ref.renderToGridArea,
      shipping = _ref.shipping,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["available", "classes", "className", "delInfo", "product", "renderToGridArea", "shipping"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();

  var _ref2 = delInfo || {},
      deliveryDates = _ref2.deliveryDates,
      warehouse = _ref2.warehouse;

  var freeShipping = ((product.adornments || []).filter(function (i) {
    return i.type === 'tag';
  }) || []).length > 0;
  return /*#__PURE__*/_react.default.createElement(_GridAreaContainer.default, (0, _extends2.default)({}, rest, {
    renderToGridArea: renderToGridArea,
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_AvailabilityFieldPreview.default, {
    product: product,
    delInfo: delInfo
  }), warehouse && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.separator
  }), /*#__PURE__*/_react.default.createElement(_ProductAvailabilityFieldPreviewWithPopup.default, null, (deliveryDates || []).map(function (i, index) {
    return /*#__PURE__*/_react.default.createElement(_ProductAvailabilityFieldPreviewWithPopupItem.default, {
      availability: i.shipping,
      date: i.date,
      key: index.toString()
    });
  })))), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.text
  }, warehouse === '1' ? t('productDetailStockInfo/available') : null, warehouse === '2' ? t('productDetailStockInfo/available') : null, warehouse === 'external' ? t('productDetailStockInfo/external') : null, !warehouse ? t('productDetailStockInfo/notAvailable') : null), available && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.labelsContainer
  }, /*#__PURE__*/_react.default.createElement(_Zoom.default, {
    in: freeShipping
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _clsx.default)(classes.free)
  }, t('productDetailStockInfo/labels/free'))), delInfo.showroom && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.separator
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.showroom
  }, t('productDetailStockInfo/labels/showroom')))), /*#__PURE__*/_react.default.createElement(_ProductDetailNote.default, {
    product: product
  }));
}

process.env.NODE_ENV !== "production" ? ProductDetailStockInfoDesktop.propTypes = {
  available: _propTypes.default.bool,
  classes: _propTypes.default.shape({
    container: _propTypes.default.string,
    free: _propTypes.default.string,
    labelsContainer: _propTypes.default.string,
    notAvailable: _propTypes.default.string,
    root: _propTypes.default.string,
    separator: _propTypes.default.string,
    showroom: _propTypes.default.string,
    text: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  delInfo: _propTypes.default.shape({
    deliveryDates: _propTypes.default.arrayOf(_propTypes.default.shape({})),
    showroom: _propTypes.default.bool,
    warehouse: _propTypes.default.string
  }),
  product: _propTypes.default.shape({
    adornments: _propTypes.default.arrayOf(_propTypes.default.shape({})),
    id: _propTypes.default.string.isRequired,
    stockQuantity: _propTypes.default.shape({
      available: _propTypes.default.bool,
      detail: _propTypes.default.arrayOf(_propTypes.default.shape({
        date: _propTypes.default.string,
        icon: _propTypes.default.node,
        location: _propTypes.default.string
      }))
    })
  }),
  renderToGridArea: _propTypes.default.string,
  shipping: _propTypes.default.shape({
    latestOrderTime: _propTypes.default.shape({}),
    shippingDate: _propTypes.default.shape({}),
    warehouse: _propTypes.default.string
  })
} : void 0;
ProductDetailStockInfoDesktop.defaultProps = {
  available: false,
  classes: undefined,
  className: undefined,
  delInfo: undefined,
  product: undefined,
  renderToGridArea: 'stockInfo',
  shipping: undefined
};
var _default = ProductDetailStockInfoDesktop;
exports.default = _default;